import React, {Component} from 'react';
import {Tooltip, Button, Modal, message, Input, Radio, Form, Divider, Icon} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {permissionCheck, uuid} from "../../../utils";
import CurrencyResourceDialog from "../../../view/resource/view/dialog/CurrencyResourceDialog";
import {rmtMessage} from "../../../view/mediaRelease/components/mess";
import ActivitiModal from "../../../view/editor/components/activitiAndBtn/ActivitiModal";
import SyncModal from "../../../view/components/syncModal/syncModal";
import MosaicReleaseImage
    from "../../../view/mediaRelease/mediaJump/imageRelease/components/mosaicReleaseComponent/MosaicReleaseImage";
import noView from "../../../view/mediaRelease/image/noView.png";
import ImagesLocally from "../../../view/mediaRelease/mediaJump/uploadAtlas/imagesLocally/ImagesLocally";
import {Scrollbars} from "react-custom-scrollbars";
import SelectColumn from "../../../view/editor/components/publishInItem/rmSelectColumn";
import OtherAttributes from "../../../view/editor/components/publishInItem/rmOtherAttributes";
import Publisher from "./Publisher";
import "../../../view/editor/components/EditorPublishInformation.css";
import DragAtlas from "./DragAtlas";


const FormItem = Form.Item;
const {TextArea} = Input;
let setting = {
    titleMaxlength: 255,
    summaryMaxlength: 1000,
};
class GroupPhoto extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "1",
            photosVisible: false, // 组图弹窗
            uploadVisible: false, // 上传弹窗
            publishDialogVisible: false,//发布设置弹窗
            atlasList: [], // 组图页面上传的数据
            uploadFileList: [], // 上传页面上传的数据
            formData: {
                title: '',
                titlePic: '',
                atlasList: [],
                variableFields: {}
            }, // 表单数据
            focusKey: [], // 获取焦点的图片
            showNewPhotos: true,
            zykFileList: [],
            imageRestrictionTypes: ["jpg", "jpeg", "gif", "png", "bmp", "webp", "webp2", "tiff", "exif", "tif"],
            activitiConfName: this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-rmapp"),
            id: "",
            modalKey:uuid(), //上传图片弹窗key
            newDate: Date.now(),
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'],
            isRepeatClick: true //设置开关来控制重复点击
        }
    }

    componentDidMount() {
        this.getSysConfigGetValueByKey();
        this.initActivitiConfig({});
    }

    // 获取配置项
    getSysConfigGetValueByKey = () => {
        setting.summaryMaxlength = this.sysConfigGetValueByKey("photosSummary.maxlength", "1000")*1;
    };

    /**设置流程配置*/
    initActivitiConfig(data) {
        let id = (this.state.id && this.state.id.length > 1 && this.state.id != 'null' && this.state.id != 'undefined') ? this.state.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";
        let noPublishConfig = this.sysConfigGetValueByKey("rmapp.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn1 = (data.statusName && noPublishConfig.indexOf(data.statusName)>-1)?false :true
        let mustNotShowPublishBtn2 = that.urlParams && that.urlParams.mustNotShowPublishBtn ? that.urlParams.mustNotShowPublishBtn : false;
        // 重置流程条件start
        let againFlag = false;
        let reloadStatus = this.sysConfigGetValueByKey("rmapp.activiti.reload.status", "");
        if (data.statusName && reloadStatus.indexOf(data.statusName) > -1) { // 弃用状态重启审核流
            againFlag = true;
        }
        let activitiConf = this.state.activitiConfName ? {type: this.state.activitiConfName} : null;
        // 如果草稿稿件可以被创建人之外的人看到，则需要手动控制审核流不要重启
        if (data && data.statusName === "草稿" && data.submitter !== userId) {
            // 当稿件状态为草稿时，审核流会自动重启，此时将activitiConf置空则审核流不重启
            activitiConf = null
        }
        // 重置流程条件end
        this.state.activityOption = {
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: 'mediaFusion',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                /**
                 * 弃用
                 */
                abandon: (item, call) => {
                    if(id) {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "新增稿件没有弃用权限！"});
                    }
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                setSourceUser: (activiti, buttonConf, call) => {
                    try {
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                            id: this.webStory.creator,
                            name: this.webStory.creatorName
                        }];
                        call({code: 1, log: "查询到返回者为：" + this.webStory.creator});
                    } catch (e) {
                        message.error(e);
                        throw e;
                    }
                },
                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if(res){
                                    message.warning("流程已撤回，稿件变为草稿状态", 1, ()=>{
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
            },//流程按钮点击事件前置js
            saveFunction: that.onOk,//稿件保存方法
            publish: that.publish,
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.onOkCall()
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver: (btns) => {
                this.activitiBtns = btns;
                this.setState({});
            },
            showBtnIcon: false,
            btnType: "primary",
            chooseFilterObject: function (users, call) {
                if (!users || users.length < 1) {
                    call && call(users);
                    return false
                }
                let mediaInfo = that.getChooseFilterObject();
                if(!mediaInfo) {
                    message.warning("过滤媒体权限失败，请先选择主栏目");
                    window.loading.hide();
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,
                }));
                call && call(receivers);
            },
            checkForm: that.checkFrom,
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            // 控制前端发布按钮的显隐
            mustNotShowPublishBtn: (mustNotShowPublishBtn1 || mustNotShowPublishBtn2) ? true : false,
        };
        this.setState({});
    }

    getChooseFilterObject = () => {
        let publishData = this.getPublish();
        let {selectColumnInfo={}} = publishData;
        let mainColumn = selectColumnInfo&&selectColumnInfo.mainColumn||{}; // 主栏目
        let columnId = mainColumn.id;
        let mediaId = mainColumn.mediaId;
        if(!(mainColumn && columnId && mediaId)) {
            window.loading.hide();
            return false
        } else {
            return {
                columnId,
                mediaId
            }
        }
    };

    // 新增组图按钮
    render() {
        return (
            <>
                <Button type={this.props.btnType || "primary"} style={{marginLeft: 16, ...(this.props.btnStyle || {})}} onClick={() => {
                    this.setState({photosVisible: true})
                }}
                >
                    {this.props.btnName || "新建组图"}
                </Button>
                {this.renderPhotos()}
                {this.renderUpload()}
                <CurrencyResourceDialog
                    onCallBackOk={(checkedData,call)=>{
                        if (checkedData.length < 1) {
                            rmtMessage.error("请先选择一张图片！");
                            call(false)
                        } else {
                            this.state.showNewPhotos =true;
                            let zykFileList = checkedData.map(item=>{
                                let newItem = {
                                    ...item,
                                    url:item.path,
                                    uid:item.id,
                                    title:item.name
                                };
                                return newItem ;
                            })
                            call(true)
                            this.state.zykFileList = zykFileList;
                            this.state.atlasList = [...this.state.atlasList,...this.state.uploadFileList, ...this.state.zykFileList];

                            this.setState({photosVisible:true, showNewPhotos: false,zykFileList: []});
                        }
                    }}
                    ref={resourceDialog=>this.resourceDialog = resourceDialog} />
            </>
        )
    }

    // 组图弹窗
    renderPhotos = () => {
        return (
            <Modal
                centered={true}
                title={this.props.btnName}
                visible={this.state.photosVisible}
                maskClosable={false}
                keyboard={false}
                onCancel={() => {
                    this.onCancel()
                }}
                bodyStyle={{height: 650}}
                width={1200}
                destroyOnClose={true}
                wrapClassName='renderPhotos'
                okText="确定"
                footer={
                    this.renderFooter()
                }
            >
                <Scrollbars style={{height: 585}}>
                    {
                        !this.state.showNewPhotos ?
                            this.renderEditPhotos()
                            : this.renderNewPhotos()
                    }
                    <style>
                        {`
                          .renderPhotos .ant-modal-body {
                            padding:25px 30px 40px 40px
                          }
                          .renderPhotos .ant-modal-footer button + button {
                            margin-left: 12px !important;
                          }
                    `}
                    </style>
                </Scrollbars>
            </Modal>
        )
    };

    renderFooter = () => {
        return (
            !this.state.showNewPhotos ?
                (<div>
                    <ActivitiModal
                        {
                            ...this.state.activityOption
                        }
                    />
                    {this.renderOtherBtn()}
                    <SyncModal ref={ref=>this.syncModal=ref}/>
                </div>)
                :
                (<div>
                    <Button onClick={() => {
                        this.onCancel()
                    }}>取消</Button>
                </div>)
        )
    };

    renderOtherBtn = () => {
        const {formData} = this.state;
        return (
            <>
                {
                    (() => {
                        if (this.activitiBtns && (this.activitiBtns.length > 0)) {
                            let configBtns = this.sysConfigGetValueByKey("rmapp.editor.saveBtn.mutex.activiti.btn", "撤回").split(",");
                            let result = true;
                            this.activitiBtns && this.activitiBtns.map(item => {
                                if (configBtns.indexOf(item.name) > -1) {
                                    result = false;
                                }
                            });
                            if(!formData.statusName || (formData.statusName === "草稿" && formData.submitter === window.currentUser.id)) {
                                result = true;
                            }
                            return result;
                        }
                        return false;
                    })() ? <Button style={{margin: "0 12px"}} onClick={() => {
                        this.okHandle(() => {
                            this.onOk(null, null)
                        })
                    }} type="primary">暂存</Button> : null
                }
                {
                    this.state.showRemarks?(
                        <Button
                            type={"primary"}
                            onClick={this.showRemarksCall}
                            style={{margin: "0 12px"}}>查看备注</Button>
                    ):null
                }
                <Button style={{margin: "0 12px"}} onClick={() => {
                    this.setState({publishDialogVisible:true})
                }}>发布设置</Button>
                {this.renderPublishDialog()}
                <Button style={{margin: "0 12px"}} onClick={() => {
                    this.onCancel()
                }}>取消</Button>
            </>
        )
    };

    //点击确定按钮,防止重复提交
    okHandle(callBack) {
        const { isRepeatClick} = this.state;
        if (isRepeatClick) {   //如果为true 开始执行
            this.setState({ isRepeatClick: false })   //将isRepeatClick变成false，将不会执行处理事件
            callBack();
            const that = this;   // 为定时器中的setState绑定this
            setTimeout(function () {       // 设置点击延迟事件，1秒后将执行
                that.setState({ isRepeatClick: true })   // 将isRepeatClick设置为true
            }, 1000);
        }
    };

    // 查看备注
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                that.syncModal.destroy();
            },
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    };

    // 关闭弹窗
    onCancel = () => {
        this.setState({photosVisible: false});
        if (typeof this.props.onCancel === 'function') {
            this.props.onCancel()
        }
    };

    onOkCall = ()=>{
        this.setState({photosVisible: false});
        if (typeof this.props.onOkCall === 'function') {
            this.props.onOkCall()
        }
    };


    record;
    showEditModal = (record) => {
        this.record = record;
        let atlasList=record.atlasList;
        atlasList.forEach((item,index)=>{
            item.uid=index;
        });
        let {mediaId, columnId, columnName, deliveryMediaFusionList, top, recommend, viewNum, variableFields} = record;
        this.mainColumn = {mediaId, columnId, columnName};
        this.deliveryNews = deliveryMediaFusionList;
        this.otherAttributesInfo = {top, recommend, viewNum, initViewNum: variableFields.initViewNum};
        this.setState({
            mediaId:record.mediaId,
            showNewPhotos: false,
            atlasList: record.atlasList,
            formData: record,
            photosVisible: true,
            id: record.id,
        }, () => {
            this.initActivitiConfig(record);
        });
    };

    // 编辑组图
    renderEditPhotos = () => {
        let {atlasList, formData} = this.state;
        let disable = (formData && formData.statusName && formData.statusName.indexOf('发布123') > -1) ? true : false;
        let {mediaName, mediaId, rmType} = this.props.dynamicParams();
        let publishType = this.record?.variableFields?.publishType;
        return (
            <div>
                <Button disabled={disable} type="primary" style={{marginBottom: 10,marginRight:20}} onClick={() => {
                    this.setState({uploadVisible: true})
                }}>本地上传</Button>
                {permissionCheck('right_to_use_zyk')?  <Button disabled={disable} type="primary" style={{marginBottom: 10}} onClick={() => {
                    this.resourceDialog.show()
                }}>资源库上传</Button>:null}
                <div>
                    <DragAtlas
                        sortList={atlasList}
                        disable={disable}
                        onDeleteCall={(uid, index) => {
                            atlasList && atlasList.length && atlasList.forEach((item, i) => {
                                if (item.uid === uid && index === i) {
                                    atlasList.splice(index, 1)
                                }
                            });
                            this.setState({atlasList})
                        }}
                        hideSetTitlePic={true}
                        onEditDescriptionCall={(file, uid) => {
                            let index = atlasList.findIndex(item => item.uid === uid);
                            atlasList[index] = file;
                            this.setState({});
                        }}
                    />
                    {/*{*/}
                    {/*    atlasList && atlasList.length ? (*/}
                    {/*        atlasList.map((item, index) => {*/}
                    {/*            return (*/}
                    {/*                <MosaicReleaseImage*/}
                    {/*                    key={index}*/}
                    {/*                    keyNum={index}*/}
                    {/*                    disable={disable}*/}
                    {/*                    file={item}*/}
                    {/*                    onDeleteCall={(uid) => {*/}
                    {/*                        atlasList&&atlasList.length&&atlasList.forEach((item,i)=>{*/}
                    {/*                            if(item.uid ===uid && index === i){*/}
                    {/*                                atlasList.splice(index,1)*/}
                    {/*                            }*/}
                    {/*                        });*/}
                    {/*                        let newAtlasList = atlasList;*/}
                    {/*                        this.setState({atlasList: newAtlasList})*/}
                    {/*                    }}*/}
                    {/*                    hideSetTitlePic={true}*/}
                    {/*                    onEditDescriptionCall={(file, uid) => {*/}
                    {/*                        let index = this.state.atlasList.findIndex(item => item.uid == uid);*/}
                    {/*                        this.state.atlasList[index] = file;*/}
                    {/*                        this.setState({});*/}
                    {/*                    }}*/}
                    {/*                    onFocusCall={(file, uid) => {*/}
                    {/*                        this.setState({focusKey: [uid]})*/}
                    {/*                    }}*/}
                    {/*                    focusKey={this.state.focusKey}*/}
                    {/*                />*/}
                    {/*            )*/}
                    {/*        })*/}
                    {/*    ) : null*/}
                    {/*}*/}
                </div>
                <Divider/>
                <Form labelCol={{span: 2}} wrapperCol={{
                    span: 21,
                    // offset: 1输入框左外边距
                }}
                      onSubmit={(e) => { // 启动了表单的回车确认功能
                      }}>
                    <FormItem
                        label={'标题'}
                        required={true}
                    >
                        <Input
                            placeholder={`请输入标题（不超过${setting.titleMaxlength}字）`}
                            maxLength={setting.titleMaxlength}
                            disabled={disable}
                            onChange={(e) => {
                                this.onFromChange({title: e.target.value})
                            }}
                            value={formData.title}
                        />
                    </FormItem>
                    {/*<FormItem*/}
                    {/*    label={'内容摘要'}*/}
                    {/*    required={false}*/}
                    {/*>*/}
                    {/*    <TextArea*/}
                    {/*        placeholder={`请输入内容摘要（不超过${setting.summaryMaxlength}字）`}*/}
                    {/*        maxLength={setting.summaryMaxlength}*/}
                    {/*        disabled={disable}*/}
                    {/*        style={{resize: 'none', background: '#eef2fb'}}*/}
                    {/*        value={formData.variableFields.summary}*/}
                    {/*        onChange={(e) => {*/}
                    {/*            this.onVariableFieldsChange({summary: e.target.value})*/}
                    {/*        }}*/}
                    {/*        autoSize={{minRows: 3, maxRows: 5}}*/}
                    {/*    />*/}
                    {/*</FormItem>*/}
                    <FormItem
                        label={"封面"}
                        required={false}
                    >
                        <Radio.Group
                            onChange={e => this.onVariableFieldsChange({picNum: e.target.value})}
                            value={([1, 3].indexOf(formData.variableFields.picNum) > -1) ? formData.variableFields.picNum : 4}
                        >
                            <Radio value={1}>单图</Radio>
                            <Radio disabled={atlasList.length < 3} value={3}>三图</Radio>
                            <Radio value={4}>自动</Radio>
                        </Radio.Group>
                    </FormItem>
                    <Publisher ref={publisherComponent=>this.publisherComponent = publisherComponent}
                               publishId={this.record?.variableFields?.publishId || mediaId}
                               publishName={this.record?.variableFields?.publishName || mediaName}
                               publishType={(publishType || publishType === 0) ? publishType : rmType}
                               permission={this.record?.variableFields?.permission}
                               publishPhoto={this.record?.variableFields?.publishPhoto}
                    />
                    <div className={'rmt-form-item'}
                         style={{display: 'flex', lineHeight: '32px', alignItems: 'flex-start', paddingRight: 32}}>
                        <div className={'photosLabel'} style={{width: 93.3, textAlign: 'right'}}>标签</div>
                        <style>
                            {
                                `
                                .rmt-form-item > .photosLabel::after {
                                    content: ':';
                                    position: relative;
                                    top: -0.5px;
                                    margin: 0 8px 0 2px;
                                }
                                .rmt-form-item > .photosLabel{
                                    color: rgba(0, 0, 0, 0.85) !important
                                }
                                `
                            }
                        </style>
                        <div style={{flex: 22}}>
                            <div style={{display: 'inline-block'}}>
                                <Input style={{width: 251, display: 'inline-block', flex: 'unset'}}
                                       onChange={(e) => {
                                           this.onFromChange({labelInputVal: e.target.value})
                                       }}
                                       value={formData.labelInputVal}
                                       disabled={disable}
                                       maxLength={50}
                                />
                                <Button icon="plus"
                                        style={{
                                            width: 32,
                                            lineHeight: '17px',
                                            margin: '0 10px',
                                            color: '#595a5b',
                                            display: 'inline-block',
                                        }}
                                        onClick={() => {
                                            if (!formData.variableFields.label) {
                                                formData.variableFields.label = []
                                            }
                                            if(formData.variableFields.label.includes(formData.labelInputVal)) {
                                                message.destroy();
                                                message.error("请勿输入相同的标签");
                                            } else {
                                                if (formData.labelInputVal) {
                                                    let newLabelArr = [...formData.variableFields.label, formData.labelInputVal];
                                                    this.onVariableFieldsChange({label: newLabelArr});
                                                    formData.labelInputVal = ""
                                                }
                                            }
                                        }}
                                />
                                {formData.variableFields && formData.variableFields.label && formData.variableFields.label.length > 0 ?
                                    formData.variableFields.label.map(item => (
                                        <div key={item}
                                             style={{
                                                 display: 'inline-block',
                                                 padding: '0 8px',
                                                 width: 'auto',
                                                 margin: '0px 8px 0px 0px',
                                                 lineHeight: '32px',
                                                 border: '1px solid #dcdcdc',
                                                 borderRadius: '5px',
                                             }}>
                                            {item}
                                            {
                                                disable ? null :
                                                    <Icon type="close"
                                                          onClick={() => {
                                                              formData.variableFields.label = formData.variableFields.label.filter(label => label !== item);
                                                              // console.log('information.label     ', formData.variableFields.label);
                                                              this.setState({});
                                                          }}
                                                          style={{
                                                              marginLeft: 8,
                                                              fontSize: 12,
                                                              cursor: 'pointer',
                                                              color: '#afafaf',
                                                          }}/>
                                            }
                                        </div>
                                    ))
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        )
    };

    deliveryNews;
    mainColumn;
    otherAttributesInfo;
    renderPublishDialog = ()=>{
        if(!this.mainColumn){
            this.mainColumn = this.props.dynamicParams();
            this.state.mediaId = this.mainColumn?.mediaId;
        }
        return <Modal
            title={"发布设置"}
            width={400}
            visible={this.state.publishDialogVisible}
            onOk={()=>{
                let {selectColumnInfo:{mainColumn, deliveryNews}, otherAttributesInfo} = this.getPublish();
                this.mainColumn = mainColumn;
                this.deliveryNews = deliveryNews;
                this.otherAttributesInfo = otherAttributesInfo;
                this.setState({publishDialogVisible:false})
            }}
            onCancel={()=>{
                this.setState({publishDialogVisible:false})
            }}
        >
            <Scrollbars
                autoHeight
                autoHeightMax={600}
            >
                <SelectColumn
                    dynamicParams={{
                        mediaId: this.state.mediaId
                    }}
                    hideMeanwhilePublishSet={true}
                    hideTitle={true}
                    showCutOperate={false}
                    selectByLocal={true}
                    selectByLocalFunction={(callBack) => {this.selectByLocal(callBack)}}
                    ref={selectColumn => {
                        this.selectColumn = selectColumn;
                        this.selectColumn && this.selectColumn.setData({mainColumn:this.mainColumn, deliveryNews:this.deliveryNews});
                    }} />
                <OtherAttributes
                    ref={otherAttributes => {
                        this.otherAttributes = otherAttributes;
                        this.otherAttributesInfo && this.otherAttributes && this.otherAttributes.setData(this.otherAttributesInfo);
                    }} />
            </Scrollbars>
        </Modal>
    };

    selectByLocal(callBack) {
        if(!this.state.atlasList.length) {
            message.warn("未找到图片");
            return;
        }
        let picList = [];
        this.state.atlasList.forEach(item => {
            picList.push({path: item.url, checked: false});
        })
        callBack(picList);
    }

    // 新增组图
    renderNewPhotos = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <img style={{width: 187}} src={noView}/>
                <div>
                    <Button onClick={() => {
                        this.setState({uploadVisible: true})
                    }} style={{cursor: "pointer", border: '1px solid ' + this.themeBgColor,marginRight:20}}>
                        本地上传
                    </Button>
                    {
                        permissionCheck('right_to_use_zyk')? <Button onClick={() => {
                            this.resourceDialog.show()
                        }} style={{cursor: "pointer", border: '1px solid ' + this.themeBgColor}}>
                            资源库上传
                        </Button>:null
                    }

                </div>

            </div>
        )
    };
    // 上传图片弹窗
    renderUpload = () => {
        let {imageRestrictionTypes} = this.state;
        let imageRestrictionType = imageRestrictionTypes.filter((item) => {
            return item
        });
        return (
            <Modal
                centered={true}
                title="本地上传"
                visible={this.state.uploadVisible}
                key = {this.state.modalKey}
                onOk={() => {
                    let atlasList = [...this.state.atlasList,...this.state.uploadFileList, ...this.state.zykFileList];
                    for (let i = 0; i < atlasList.length; i++) {
                        let atlasListItem = atlasList[i];
                        if(atlasListItem.status === "uploading") {
                            rmtMessage.warning("正在上传，请稍等。");
                            return false;
                        }
                    }
                    this.state.atlasList = atlasList.map(item=>{
                        let newItem = {
                            ...item,
                            title:item.name
                        };
                        return newItem ;
                    })
                    if (this.state.atlasList.length === 0) {
                        rmtMessage.warning('请先选择一张图片！');
                        return false;
                    }
                    this.setState({uploadVisible: false, showNewPhotos: false,modalKey:uuid(),uploadFileList:[],zykFileList:[]})

                }}
                onCancel={() => {
                    this.setState({uploadVisible: false})
                }}
                maskClosable={false}
                width={800}
                wrapClassName='renderUpload'
            >
                <div className="interval">
                    <div style={{padding: 24}}>
                        <Tooltip placement="right"
                                 title={imageRestrictionTypes ? imageRestrictionType.join(", ") : null}>
                            <span style={{color: '#F56C6C'}}>仅支持{['jpg','jpeg', 'gif', 'png', 'bmp'].join("，")}等格式图片</span>
                        </Tooltip>
                        <ImagesLocally onChange={(uploadFileList) => {
                            this.setState({uploadFileList})
                        }}/>
                    </div>
                    <style>
                        {`
                         .renderUpload .interval .ant-tabs-bar{padding: 0px 32px;}
                         .renderUpload .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                          .renderUpload .ant-modal-body {
                            padding:10px 0 
                          }
                    `}
                    </style>
                </div>

            </Modal>
        )
    };

    // 表单校验
    checkFrom = (activiti, call) => {
        let {atlasList, formData} = this.state;
        let title = formData.title;
        if (!(atlasList && atlasList.length)) {
            message.destroy();
            message.warn("请先上传图片");
            window.loading.hide();
            return false
        }
        if (!(title && title.length)) {
            message.destroy();
            message.warn("请先填写标题");
            window.loading.hide();
            return false
        }
        let newAtlasList = atlasList.map((item,index) => ({
            describe: item.describe,
            title: item.title,
            url: item.url || item.path,
            uid:item.uid||index
        }));
        let tempMainColumn = {};
        Object.assign(tempMainColumn, this.mainColumn);
        delete tempMainColumn.id;
        delete tempMainColumn.key;
        if(tempMainColumn.title) {
            delete tempMainColumn.title;
        }
        if(tempMainColumn.treeName && tempMainColumn.treeId) {
            tempMainColumn.columnName = tempMainColumn.treeName;
            tempMainColumn.columnId = tempMainColumn.treeId;
        }
        if(JSON.stringify(tempMainColumn) === "{}"){
            let {columnId, columnName} = this.props.dynamicParams();
            tempMainColumn = {columnId, columnName};
        }
        let body = {
            ...formData,
            atlasList: newAtlasList,
            // ...(this.props.dynamicParams()),
            ...tempMainColumn,
            ...this.otherAttributesInfo,
            deliveryMediaFusionList:this.deliveryNews,
            mediaName: this.state.mediaName,
            newdate: this.state.newDate,

        };
        if(!body.variableFields){
            body.variableFields = {};
        }
        body.variableFields = {
            ...body.variableFields,
            ...this.publisherComponent.getData(),
            initViewNum: (this.otherAttributesInfo && this.otherAttributesInfo.initViewNum) || 0
        };
        if(!body.variableFields.publishId){
            message.destroy();
            message.warn("请选择发布账号");
            window.loading.hide();
            return ;
        }
        if (!this.state.id) {
            // 新增稿件添加创建人
            let currentUser = window.currentUser ? window.currentUser : {};
            body = {
                ...body,
                submitter: currentUser.id,
            };
        } else {
            body = {
                ...body,
                submitter: formData.submitter,
            };
        }
        body.type = 1;
        call&&call();
        return body
    };

    // 组图确认（发布）
    onOk = (activiti, call) => {
        let body = this.checkFrom();
        if (!body) {
            call && call(false);
            return false
        };
        this.save(activiti, call, body)
    };

    publishData={};

    // 暂存
    save = (activiti, call, params) => {
        let that = this;
        let url = '/cm-sites-mmp/mf/save';
        // 获取发布等状态
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        this.request({
            url,
            method: 'POST',
            body: params,
            contentType: 'json',
            callBack: function (res, status, allData) {
                if (res) {
                    that.publishData=res;
                    // 获取发布状态
                    let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
                    if (statusNameTemp && activitiConfName.indexOf(statusNameTemp) > -1) {
                        that.state.id = res.id;
                        call && call(res)
                    } else {
                        call && call(res);
                        that.state.id = res.id;
                        if (!activiti) {//点击了暂存按钮
                            message.success('保存成功！', 0.5, () => {
                                that.onOkCall()
                            });
                        }
                    }
                    that.updateProcessAndData(res)
                } else {
                    message.error('保存失败！');
                    call && call(false);
                }
            },
            errorCallBack: function (e) {
                call && call(false);
                message.error('保存失败！');
            }
        });
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body,
            callBack: (res)=>{

            }
        })
    };

    publish = (statusName, activiti, call) => {
        if(this.publishData && this.publishData.id) {
            let url = '/cm-sites-mmp/mf/status/'+this.publishData.id;
            this.request({
                url,
                method: 'POST',
                body: {
                    status: "已发布"
                },
                callBack: () => {
                    call&&call({status: true, msg: "流程推进后发布成功。"});
                },
                errorCallBack: function (e) {
                    call&&call({status: false, msg: "流程推进后发布失败。"});
                }
            });
        } else {
            message.warn("发布失败！稿件id丢失")
        }
    };

    /**
     * 稿件修改状态
     */
    updateStatusName = (statusName, activiti, call) => {
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "status":statusName,
        };
        this.request({
            url: '/cm-sites-mmp/mf/status/'+id,
            method: 'POST',
            body: params,
            callBack: function (res) {
                if (res) {
                    call&&call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call&&call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call&&call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    // 上传前校验
    beforeUpload = file => {
        return true;
    };
    // 表单
    onFromChange(data) {
        this.state.formData = {
            ...this.state.formData,
            ...data
        };
        this.setState({});
    }

    onVariableFieldsChange(data) {
        this.state.formData.variableFields = {
            ...this.state.formData.variableFields,
            ...data
        }
        this.setState({})
    }

    getPublish(){
        let selectColumnInfo = this.selectColumn?.getData() || {};
        if(JSON.stringify(selectColumnInfo) === "{}"){
            let {columnId, columnName,mediaId} = this.props.dynamicParams();
            selectColumnInfo.mainColumn = {id:columnId, columnName,mediaId};
        }
        let otherAttributesInfo = this.otherAttributes?.getData() || {};
        return {selectColumnInfo, otherAttributesInfo}
    }

}

export default GroupPhoto;
